import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propFunc, propShape, propStr, propBool, propId, } from '../../../../../../../helpers/custom-prop-types';
import PencilIcon from '../../../../../../Icon/Svg/PencilIcon';
import Hover from '../../../../../../Ui/System/Hover';
import Tooltip from '../../../../../../Ui/Tooltip/Tooltip';
import FolderNameForm from './FolderNameForm';
const FolderName = (props) => {
    const { fieldClassName, formClassName, id, initialValues, inputRef, isShowForm, isShowTooltip, name, onMouseEnter, onMouseLeave, onSubmit, showForm, textRowClassName, tooltipClassName, tooltipPopperOptions, } = props;
    if (isShowForm) {
        return (_jsx(FolderNameForm, { fieldClassName: fieldClassName, form: `FolderNameForm_${id}`, formClassName: formClassName, initialValues: initialValues, inputRef: inputRef, onSubmit: onSubmit, placeholder: name }));
    }
    return (_jsxs("div", Object.assign({ className: clsx('proffit_search_folder_name_text', textRowClassName) }, { children: [_jsx("span", Object.assign({ className: 'text_value', onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: _jsx(Tooltip, Object.assign({ className: clsx('text_tooltip', tooltipClassName), html: _jsx("div", { children: name }), open: isShowTooltip, popperOptions: tooltipPopperOptions, position: 'top', trigger: 'manual' }, { children: name })) })), _jsx(Hover, { children: _jsx("button", Object.assign({ className: 'text_button', onClick: showForm, type: 'button' }, { children: _jsx(PencilIcon, { className: 'button_svg' }) })) })] })));
};
FolderName.propTypes = {
    fieldClassName: propStr(),
    formClassName: propStr(),
    id: propId().isRequired,
    initialValues: propShape().isRequired,
    inputRef: propShape().isRequired,
    isShowForm: propBool().isRequired,
    isShowTooltip: propBool(),
    name: propStr().isRequired,
    onMouseEnter: propFunc(),
    onMouseLeave: propFunc(),
    onSubmit: propFunc().isRequired,
    showForm: propFunc().isRequired,
    textRowClassName: propStr(),
    tooltipClassName: propStr(),
    tooltipPopperOptions: propShape(),
};
FolderName.defaultProps = {
    fieldClassName: '',
    formClassName: '',
    isShowTooltip: false,
    onMouseEnter: undefined,
    onMouseLeave: undefined,
    textRowClassName: '',
    tooltipClassName: '',
    tooltipPopperOptions: undefined,
};
export default FolderName;
